/* prettier-ignore */
import { createRoute, createRouter } from "@tanstack/react-router";
import { WaitlistsScreen } from "@/app/Waitlists/Screens/WaitlistsScreen";
import { callbackLeadsRoute } from "@/app/CallbackLeads/Routes/callbackLeadRoutes";
import {
  bookingChangeRequestsRoute,
  bookingCreateRoute,
  bookingDetailRoute,
  bookingFindRelocationRoute,
  bookingPaymentsRoute,
  bookingReceiptsRoute,
  bookingRecordLayout,
  bookingRoute,
  bookingsRoute,
  bookingTableRoute,
  bookingTasksRoute,
} from "@/app/Bookings/Routes/bookingRoutes";
import {
  supplierActiveLinesRoute,
  supplierActivityRoute,
  supplierAdsRoute,
  supplierBillingRoute,
  supplierBookingsRoute,
  supplierCreateRoute,
  supplierDefaultHoursRoute,
  supplierDetailRoute,
  supplierGapRentalsRoute,
  supplierInsuranceRoute,
  supplierLogisticsRoute,
  supplierNotificationRoute,
  supplierOfficesRoute,
  supplierRecordLayout,
  supplierRecordRoute,
  supplierRelocationsRoute,
  suppliersRoute,
  supplierTableRoute,
  supplierVehiclesRoute,
} from "./app/Suppliers/Routes/supplierRoutes";
import {
  invoiceActivityRoute,
  invoiceCreateRoute,
  invoiceDetailRoute,
  invoiceRecordLayoutRoute,
  invoiceRoute,
  invoicesRoute,
  invoiceTableRoute,
} from "./app/Invoices/Routes/invoiceRoutes";
import {
  vehicleActivityRoute,
  vehicleCreateRoute,
  vehicleDetailRoute,
  vehicleEmptyRoute,
  vehicleImagesRoute,
  vehicleListRoute,
  vehicleRoute,
} from "@/app/Vehicles/Routes/vehicleRoutes";
import {
  userActivityRoute,
  userDetailRoute,
  userListRoute,
  userOrganisationsRoute,
  userRoute,
  usersLayoutRoute,
} from "@/app/Users/Routes/userRoutes";
import {
  organisationActivityRoute,
  organisationDetailRoute,
  organisationInvoicesRoute,
  organisationListRoute,
  organisationMembersRoute,
  organisationRoute,
  organisationsLayoutRoute,
  organisationSuppliersRoute,
} from "@/app/Organisations/Routes/organisationRoutes";

import {
  paymentDetailRoute,
  paymentListRoute,
  paymentRoute,
} from "@/app/Payments/Routes/paymentRoute";
import {
  assignmentRecordRoute,
  assignmentsRoute,
  proDriverDetailRoute,
  proDriverIncidentsRoute,
  proDriverRoute,
  proDriversLayout,
  proDriverTableRoute,
  proDriverTasksRoute,
  proDriverThreadsRoute,
  proDriverThreadsIndexRoute,
  proDriverThreadRoute,
  workOrderActivityRoute,
  workOrderDetailsRoute,
  workOrderBillingRoute,
  workOrderDriversRoute,
  workOrderIncidentsRoute,
  workOrderMessagesRoute,
  workOrderMessagesIndexRoute,
  workOrderMessageThreadRoute,
  workOrderRecordLayoutRoute,
  workOrderRecordSidebarLayout,
  workOrderRecordRoute,
  workOrdersRoute,
  workOrderTableRoute,
} from "@/app/ProDrivers/Common/Routes/proDriverRoutes";
import {
  incidentActivityRoute,
  incidentDetailsRoute,
  incidentRecordRoute,
  incidentRegisterRoute,
} from "@/app/Incidents/Routes/incidentRoutes";

import {
  officeActivityRoute,
  officeBookingsRoute,
  officeCreateRoute,
  officeDetailRoute,
  officeEmptyRoute,
  officeListRoute,
  officeOpenHoursRoute,
  officeRelocationsRoute,
  officeRoute,
} from "@/app/Offices/Routes/officeRoutes";
import {
  cityCreateRoute,
  cityDetailRoute,
  cityListRoute,
  cityRoute,
  cityTripRoute,
} from "@/app/Cities/Cities/Routes/cityRoutes";
import {
  contactCreditRoute,
  contactDetailRoute,
  contactEntityRoute,
  contactInvoiceRoute,
  contactRoute,
  contactsRoute,
  contactStatementRoute,
} from "@/app/Contacts/Routes/contactRoute";
import {
  relocationActivityRoute,
  relocationAdsRoute,
  relocationBookingsRoute,
  relocationCreateRoute,
  relocationDetailsRoute,
  relocationGenerationRoute,
  relocationLinesRoute,
  relocationNotFoundRoute,
  relocationProDriversRoute,
  relocationRecordLayout,
  relocationRoute,
  relocationsRoute,
  relocationTableRoute,
  relocationWaitlistRoute,
  gapRentalsRoute,
  gapRentalTableRoute,
  gapRentalRoute,
  gapRentalDetailsRoute,
  gapRentalBookingsRoute,
  gapRentalWaitlistRoute,
  gapRentalActivityRoute,
  gapRentalAdsRoute,
  gapRentalGenerationRoute,
} from "@/app/Relocations/Routes/relocationRoute";
import {
  adminReportRoute,
  receivablesReconciliationReportRoute,
  reportBookingsRoute,
  reportInvoicesRoute,
  reportReceiptsRoute,
  reportRelocationFlowRoute,
  reportProDriverSuppliersRoute,
  reportRelocationsRoute,
  reportRoute,
  reportSalesRoute,
  reportSelectionRoute,
  reportSuppliersRoute,
  reportWorkOrdersRoute,
  reportAssignmentsRoute,
} from "@/app/Reports/Reports/Routes/reportRoutes";
import {
  settingBillingEntityRoute,
  settingBillingIndexRoute,
  settingBillingRoute,
  settingIntegrationsListRoute,
  settingIntegrationsRoute,
  settingNotificationRoute,
  settingsAvailabilityRoute,
  settingsCitiesRoute,
  settingsCityDrawerRoute,
  settingsDefaultRatesRoute,
  settingsGapRentalsRoute,
  settingsGeneralRoute,
  settingsInsuranceRoute,
  settingsIntegrationRotue,
  settingsOfficeRoute,
  settingsOrganisationRoute,
  settingsReportRoute,
  settingsRoute,
  settingsSuppliersRoute,
  settingsToolsRoute,
  settingsAgreementsRoute,
  settingsActiveLinesRoute,
  settingsActivityRoute,
  settingsVehicleRoute,
} from "@/app/Settings/Settings/Routes/settingsRoute";
import {
  adminAgreementsRoute,
  adminCitiesRoute,
  adminCityDrawerRoute,
  adminDefaultRatesRoute,
  adminRoute,
  adminRelocationPagesRoute,
  adminToolsRoute,
  adminTripsRoute,
  adminTripRecordRoute,
  adminTripDetailRoute,
  adminTripFaqsRoute,
  adminTripArticlesRoute,
} from "@/app/Admin/Routes/adminRoutes";
import {
  acceptInvitationRoute,
  changeOrganisationRedirectRoute,
  changeOrganisationRoute,
  forgotPasswordRoute,
  hasOrgsLayout,
  noOrgLayoutRoute,
  noOrgLoggedInLayout,
  noOrgsLayout,
  signInRoute,
  signUpRoute,
} from "@/app/Auth/Routes/loginRoutes";
import {
  onboardingCreateOrgRoute,
  onboardingCreateOrJoinRoute,
  onboardingCreateSupplierRoute,
  onboardingRoute,
} from "@/app/Onboarding/Routes/onboardingRoutes";
import { dashboardRoute } from "@/app/Dashboard/routes/dashboardRoutes";
import {
  importParentRoute,
  importSelectSupplierRoute,
  importSpreadsheetRoute,
  importSupplierRoute,
  importUploadRoute,
} from "@/app/Import/routes/importRoutes";
import {
  quoteActivityRoute,
  quoteDetailRoute,
  quoteInvoicesRoute,
  quoteRecordLayoutRoute,
  quoteRecordRoute,
  quotesRoute,
  quoteTableRoute,
} from "./app/Quotes/routes/quoteRoutes";
import { appLayoutRoute } from "@/routes/layout-routes";
import { selectSupplierRoute } from "@/routes/select-supplier-route";
import { rootRoute } from "@/routes/root-route";
import { rootIndexRoute } from "@/routes/root-index-route";
import { legacyRedirectRoute } from "@/routes/legacy-redirect-route";
import { agentRunsRoute } from "@/app/Agents/Routes/agentRoutes";
import { emailEventsRoute } from "@/app/EmailEvents/Routes/emailEventRoutes";
import { profileRoute } from "@/app/Profile/Routes/profileRoutes";
import {
  blogAuthorsRoute,
  blogPostEditRoute,
  blogPostTranslationsRoute,
  blogPostListRoute,
  blogPostRoute,
  blogPostsRoute,
  blogTagsRoute,
} from "@/app/Blogs/Routes/blogRoutes";
import { adTableRoute } from "@/app/Promotions/Routes/adRoutes";

const waitlistsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/waitlists",
  component: WaitlistsScreen,
});

// Create the route tree using your routes
const routeTree = rootRoute.addChildren([
  rootIndexRoute,
  appLayoutRoute.addChildren([
    dashboardRoute,
    adTableRoute,
    quotesRoute.addChildren([
      quoteTableRoute,
      quoteRecordLayoutRoute.addChildren([
        quoteRecordRoute.addChildren([
          quoteDetailRoute,
          quoteActivityRoute,
          quoteInvoicesRoute,
        ]),
      ]),
    ]),
    suppliersRoute.addChildren([
      supplierTableRoute,
      supplierCreateRoute,
      supplierRecordLayout.addChildren([
        supplierRecordRoute.addChildren([
          supplierDetailRoute,
          supplierVehiclesRoute,
          supplierOfficesRoute,
          supplierRelocationsRoute,
          supplierGapRentalsRoute,
          supplierDefaultHoursRoute,
          supplierActiveLinesRoute,
          supplierActivityRoute,
          supplierAdsRoute,
          supplierLogisticsRoute,
          supplierBookingsRoute,
          supplierInsuranceRoute,
          supplierBillingRoute,
          supplierNotificationRoute,
        ]),
      ]),
    ]),
    bookingsRoute.addChildren([
      bookingTableRoute,
      bookingRecordLayout.addChildren([
        bookingCreateRoute,
        bookingRoute.addChildren([
          bookingDetailRoute,
          bookingFindRelocationRoute,
          bookingChangeRequestsRoute,
          bookingPaymentsRoute,
          bookingTasksRoute,
          bookingReceiptsRoute,
        ]),
      ]),
    ]),
    relocationsRoute.addChildren([
      relocationTableRoute,
      relocationRecordLayout.addChildren([
        relocationCreateRoute,
        relocationNotFoundRoute,
        relocationRoute.addChildren([
          relocationDetailsRoute,
          relocationAdsRoute,
          relocationWaitlistRoute,
          relocationLinesRoute,
          relocationActivityRoute,
          relocationBookingsRoute,
          relocationGenerationRoute,
          relocationProDriversRoute,
        ]),
      ]),
    ]),
    gapRentalsRoute.addChildren([
      gapRentalTableRoute,
      gapRentalRoute.addChildren([
        gapRentalDetailsRoute,
        gapRentalBookingsRoute,
        gapRentalWaitlistRoute,
        gapRentalActivityRoute,
        gapRentalAdsRoute,
        gapRentalGenerationRoute,
      ]),
    ]),
    vehicleListRoute.addChildren([
      vehicleCreateRoute,
      vehicleRoute.addChildren([
        vehicleDetailRoute,
        vehicleImagesRoute,
        vehicleActivityRoute,
        vehicleEmptyRoute,
      ]),
    ]),
    cityListRoute.addChildren([
      cityCreateRoute,
      cityRoute.addChildren([cityDetailRoute, cityTripRoute]),
    ]),
    officeListRoute.addChildren([
      officeEmptyRoute,
      officeCreateRoute,
      officeRoute.addChildren([
        officeDetailRoute,
        officeOpenHoursRoute,
        officeActivityRoute,
        officeBookingsRoute,
        officeRelocationsRoute,
      ]),
    ]),
    profileRoute,
    waitlistsRoute,
    callbackLeadsRoute,
    blogPostsRoute.addChildren([
      blogPostListRoute,
      blogPostRoute.addChildren([blogPostEditRoute, blogPostTranslationsRoute]),
    ]),
    blogAuthorsRoute,
    blogTagsRoute,
    agentRunsRoute,
    emailEventsRoute,
    importParentRoute.addChildren([
      importSelectSupplierRoute,
      importSupplierRoute.addChildren([
        importUploadRoute,
        importSpreadsheetRoute,
      ]),
    ]),
    contactsRoute.addChildren([
      contactRoute.addChildren([
        contactDetailRoute,
        contactEntityRoute,
        contactInvoiceRoute,
        contactCreditRoute,
        contactStatementRoute,
      ]),
    ]),
    organisationsLayoutRoute.addChildren([
      organisationListRoute,
      organisationRoute.addChildren([
        organisationDetailRoute,
        organisationMembersRoute,
        organisationSuppliersRoute,
        organisationInvoicesRoute,
        organisationActivityRoute,
      ]),
    ]),
    usersLayoutRoute.addChildren([
      userListRoute,
      userRoute.addChildren([
        userDetailRoute,
        userOrganisationsRoute,
        userActivityRoute,
      ]),
    ]),
    reportRoute.addChildren([
      reportSelectionRoute,
      reportBookingsRoute,
      reportInvoicesRoute,
      reportWorkOrdersRoute,
      reportAssignmentsRoute,
      reportReceiptsRoute,
      reportRelocationsRoute,
      reportRelocationFlowRoute,
      reportSalesRoute,
      reportSuppliersRoute,
      reportProDriverSuppliersRoute,
      adminReportRoute,
      receivablesReconciliationReportRoute,
    ]),

    proDriversLayout.addChildren([
      workOrdersRoute.addChildren([workOrderTableRoute]),
      assignmentsRoute.addChildren([assignmentRecordRoute]),
      proDriverThreadsRoute.addChildren([
        proDriverThreadsIndexRoute,
        proDriverThreadRoute,
      ]),
      proDriverTasksRoute,
      incidentRegisterRoute,
      proDriverTableRoute.addChildren([
        proDriverRoute.addChildren([
          proDriverDetailRoute,
          proDriverIncidentsRoute,
        ]),
      ]),
    ]),
    incidentRecordRoute.addChildren([
      incidentDetailsRoute,
      incidentActivityRoute,
    ]),
    workOrderRecordSidebarLayout.addChildren([
      workOrderRecordLayoutRoute.addChildren([
        workOrderRecordRoute.addChildren([
          workOrderDetailsRoute,
          workOrderBillingRoute,
          workOrderDriversRoute,
          workOrderActivityRoute,
          workOrderIncidentsRoute,
          workOrderMessagesRoute.addChildren([
            workOrderMessagesIndexRoute,
            workOrderMessageThreadRoute,
          ]),
        ]),
      ]),
    ]),

    paymentListRoute.addChildren([
      paymentRoute.addChildren([paymentDetailRoute]),
    ]),
    invoicesRoute.addChildren([
      invoiceTableRoute,
      invoiceCreateRoute,
      invoiceRecordLayoutRoute.addChildren([
        invoiceRoute.addChildren([invoiceDetailRoute, invoiceActivityRoute]),
      ]),
    ]),
    adminTripRecordRoute.addChildren([
      adminTripDetailRoute,
      adminTripFaqsRoute,
      adminTripArticlesRoute,
    ]),
    adminRoute.addChildren([
      adminCitiesRoute.addChildren([adminCityDrawerRoute]),
      adminTripsRoute,
      adminDefaultRatesRoute,
      adminRelocationPagesRoute,
      adminToolsRoute,
      adminAgreementsRoute,
    ]),
    settingsRoute.addChildren([
      settingsGeneralRoute,
      settingsAvailabilityRoute,
      settingsInsuranceRoute,
      settingsGapRentalsRoute,
      settingNotificationRoute,
      settingBillingRoute.addChildren([
        settingBillingIndexRoute,
        settingBillingEntityRoute,
      ]),
      settingsSuppliersRoute,
      settingsVehicleRoute,
      settingsOfficeRoute,
      settingsReportRoute,
      settingsCitiesRoute.addChildren([settingsCityDrawerRoute]),
      settingsOrganisationRoute,
      settingsToolsRoute,
      settingsAgreementsRoute,
      settingsActiveLinesRoute,
      settingsActivityRoute,
      settingIntegrationsRoute.addChildren([
        settingIntegrationsListRoute,
        settingsIntegrationRotue,
      ]),
      settingsDefaultRatesRoute,
    ]),
  ]),
  noOrgLayoutRoute.addChildren([
    signInRoute,
    signUpRoute,
    forgotPasswordRoute,
    acceptInvitationRoute,

    noOrgLoggedInLayout.addChildren([
      onboardingCreateOrgRoute,
      hasOrgsLayout.addChildren([
        changeOrganisationRoute,
        onboardingCreateSupplierRoute,
        selectSupplierRoute,
      ]),
      noOrgsLayout.addChildren([
        onboardingRoute.addChildren([onboardingCreateOrJoinRoute]),
      ]),
    ]),
  ]),
  changeOrganisationRedirectRoute,
  legacyRedirectRoute,
]);

// Create the router using your route tree
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultHashScrollIntoView: { behavior: "smooth", block: "nearest" },
  context: {
    // auth will initially be undefined
    // We'll be passing down the auth state from within a React component
    auth: undefined!,
  },
});
